import { BaseService } from "./BaseService";

export const IpgService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipg/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos ipgs:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('ipg/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas ipgs:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipg', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de ipgs:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`ipg/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de ipgs:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`ipg/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de ipgs:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipg/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir ipgs:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipg/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar ipgs:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipg/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar ipgs:', error);
            return false;
        }
    }, 
}